// Copyright ©️ 2026 eVolve MEP, LLC

import type { Task } from '@evolvemep/api-ts';
import { notifications } from '@mantine/notifications';

import { ReopenTaskModal, type ReopenTaskModalModeProps } from 'modules/Shop/Tasks/TaskViewer/ReopenTaskModal';

type Props = {
  opened: boolean;
  onClose: () => void;
  /** Called with the updated task once it has been resumed. */
  onTaskResumed: (task: Task) => Promise<void> | void;
} & ReopenTaskModalModeProps;

/**
 * Confirms resuming a completed task, putting it back in progress.
 */
export const ResumeTaskModal = ({ onTaskResumed, ...props }: Props) => (
  <ReopenTaskModal
    {...props}
    title="Resume task"
    confirmationText="Resume"
    gerund="resuming"
    outcome="be set to In progress"
    onTaskReopened={async (updatedTask, workCellTask) => {
      await onTaskResumed(updatedTask);
      notifications.show({
        title: 'Successfully resumed',
        message: `Task ${workCellTask.taskName} was set to In progress.`,
        color: 'green',
      });
    }}
  />
);
